import CrmPage from "components/routes/crmGroup/CrmPage";

export default () => <CrmPage />;

export { default as path } from "./pathname";
